import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

@NgComponent({
    token: Token.KbButton
})
export class KbButton extends Directive {
    constructor($timeout: ng.ITimeoutService) {
        super();
        this.restrict = "E";
        this.replace = true;
        this.transclude = true;
        this.scope = {
            ngClick: "&",
            textColor: "=?",
            backgroundColor: "=?"
        }

        this.template = Dirs.component("kb-button");
    }
}
